// extracted by mini-css-extract-plugin
export default {"release-notes-collapsible":"w_bZ","header-collapsible":"w_b0"};